export default __webpack_public_path__ + "img/gMMVgPyl.30ac446d.svg";